module.exports = __webpack_public_path__ + "static/13-f519a8e63fb827738845dbaddf050e33.jpg";